
import React from 'react'
import styled from 'styled-components'
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import ExperienceCard from '../Cards/ExperienceCard';
import { experiences } from '../../data/constants';
import { RoughCircle, RoughUnderline } from '../common/Rough';
import { ChalkDoodles } from '../common/Doodles';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    z-index: 1;
    align-items: center;
    padding: 40px 16px 80px 16px;
    @media (max-width: 960px) {
        padding: 20px 8px;
    }
`;

const Wrapper = styled.div`
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    width: 100%;
    max-width: 1000px;
    padding: 40px 0;
    gap: 12px;
    @media (max-width: 960px) {
        flex-direction: column;
    }
`;

const Title = styled.div`
font-family: 'Caveat', cursive;
font-size: 52px;
text-align: center;
font-weight: 700;
margin-top: 20px;
  color: ${({ theme }) => theme.text_primary};
  @media (max-width: 768px) {
      margin-top: 12px;
      font-size: 40px;
  }
`;

const TitleUnderline = styled.div`
  width: 170px;
  margin: -8px auto 0 auto;
`;

const TimelineSection = styled.div`
    width: 100%;
    max-width: 1000px;
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;

    .MuiTimelineConnector-root {
      background-color: transparent;
      border-left: 3px dashed ${({ theme }) => theme.text_secondary}88;
      width: 0;
    }
    .MuiTimelineItem-root::before {
      display: none;
    }
`;



const index = () => {
    return (
      <Container id="experience">
        <ChalkDoodles seedBase={13} count={8} />
        <Wrapper>
          <Title>Experience</Title>
          <TitleUnderline>
            <RoughUnderline height={16} strokeWidth={3.5} />
          </TitleUnderline>
          <TimelineSection>
            <Timeline>
              {experiences.map((experience, index) => (
                <TimelineItem key={experience.id}>
                  <TimelineSeparator>
                    <RoughCircle size={22} strokeWidth={2} roughness={2.6} />
                    {index !== experiences.length - 1 && (
                      <TimelineConnector />
                    )}
                  </TimelineSeparator>
                  <TimelineContent sx={{ py: "12px", px: 2 }}>
                    <ExperienceCard experience={experience} flip={index % 2 === 0} />
                  </TimelineContent>
                </TimelineItem>
              ))}
            </Timeline>
          </TimelineSection>
        </Wrapper>
      </Container>
    );
}

export default index
